// frontend/src/utils/validators.ts
/**
 * 🧠 Pensado por Alcélio Gomes - Codificado com Claude Code
 * 🚀 NeuroAgentes [SimpleX] www.simplex.tec.br
 * 
 * AUDITORIA: Validators centralizados para toda aplicação.
 * Elimina duplicação de lógica de validação em forms e components.
 */

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidPhone = (phone: string): boolean => {
  const numbers = phone.replace(/\D/g, '');
  return numbers.length === 10 || numbers.length === 11;
};

export const isNotEmpty = (value: string): boolean => {
  return value.trim().length > 0;
};

export const isStrongPassword = (password: string): boolean => {
  const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  return strongRegex.test(password);
};

export interface ValidationRule {
  validator: (value: unknown) => boolean;
  message: string;
}

export const validate = (value: unknown, rules: ValidationRule[]): string | null => {
  for (const rule of rules) {
    if (!rule.validator(value)) {
      return rule.message;
    }
  }
  return null;
};

export const commonRules = {
  required: (message = 'Campo obrigatório'): ValidationRule => ({
    validator: (value) => value !== null && value !== undefined && isNotEmpty(String(value)),
    message
  }),
  
  email: (message = 'Email inválido'): ValidationRule => ({
    validator: (value) => {
      if (typeof value !== 'string') return false;
      return isValidEmail(value);
    },
    message
  }),
  
  phone: (message = 'Telefone inválido'): ValidationRule => ({
    validator: (value) => {
      if (typeof value !== 'string') return false;
      return isValidPhone(value);
    },
    message
  })
};

/**
 * Validadores específicos para contexto de negócio
 */
export const businessValidators = {
  isContextComplete: (context: unknown): boolean => {
    if (!context || typeof context !== 'object' || context === null) return false;
    
    // Verificar campos essenciais do contexto (PersonalityStep usa estes campos)
    const essentialFields = ['businessDescription', 'targetAudience', 'primaryGoal'];
    const typedContext = context as Record<string, unknown>;
    
    return essentialFields.every(field => 
      typedContext[field] && 
      typeof typedContext[field] === 'string' && 
      (typedContext[field] as string).trim().length > 0
    );
  }
};